import React from 'react';
import classnames from 'classnames';
import {Link} from '@reach/router';

import * as styles from './SidebarLink.module.css';

export function SidebarLink({children, partialCurrency, neverActive, ...props}) {
  return (
    <Link
      {...props}
      getProps={({isCurrent, isPartiallyCurrent}) => {
        return {
          className: classnames(styles.SidebarLink, {
            [styles['SidebarLink-Active']]:
              !neverActive && (isCurrent || (partialCurrency && isPartiallyCurrent)),
          }),
        };
      }}
    >
      {children}
    </Link>
  );
}
